import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EnvironmentConfigurationDetailTab from './EnvironmentConfigurationDetailTab';
import SettingsRow from './SettingsRow';
import AmqpDetailTab from './AmqpDetailTab';
import RequestRatesAndLimitsDetail from './RequestRatesAndLimitsDetail';
import ClientApplicationsDetail from './ClientApplicationsDetail';
import FailoverDetailTab from './FailoverDetailTab';
import OaadLdapDetailTab from './OaadLdapDetailTab';

function Settings() {
    const { t } = useTranslation();
    return (
        <>
            <h4><FontAwesomeIcon icon="cog" />&nbsp;{t('title.settings')}</h4>
            <div className="settings-list">
                <div className="rich-list-row rich-list-header settings-list--header">
                    <div className="rich-list-row--arrow-mobile" />
                    <div className="settings-row-header--values--name">
                        {t('settings.list-header.name')}
                    </div>
                    <div className="settings-row-header--values--description">
                        {t('settings.list-header.description')}
                    </div>
                    <div className="rich-list-row--arrow" />
                </div>
                <SettingsRow
                    name={t('settings.amqp.name')}
                    detailPath="amqp"
                    description={t('settings.amqp.description')}
                >
                    <AmqpDetailTab />
                </SettingsRow>
                <SettingsRow
                    name={t('settings.request-rates-and-limits.name')}
                    detailPath="request-rates-and-limits"
                    description={t('settings.request-rates-and-limits.description')}
                >
                    <RequestRatesAndLimitsDetail />
                </SettingsRow>
                <SettingsRow
                    name={t('settings.client-applications.name')}
                    detailPath="client-applications"
                    description={t('settings.client-applications.description')}
                >
                    <ClientApplicationsDetail />
                </SettingsRow>
                <SettingsRow
                    name={t('settings.failover.name')}
                    detailPath="failover"
                    description={t('settings.failover.description')}
                >
                    <FailoverDetailTab />
                </SettingsRow>
                <SettingsRow
                    name={t('settings.env-configuration.name')}
                    detailPath="env-configuration"
                    description={t('settings.env-configuration.description')}
                >
                    <EnvironmentConfigurationDetailTab />
                </SettingsRow>
                <SettingsRow
                    name={t('settings.oaad-ldap.name')}
                    detailPath="oaad-ldap"
                    description={t('settings.oaad-ldap.description')}
                >
                    <OaadLdapDetailTab />
                </SettingsRow>
            </div>
        </>
    );
}

export default Settings;
